module.exports = __webpack_public_path__ + "static/scale-model-of-willamette-valley-visitors-association-in-salem-oregon-a464a6fbedb51cf63a9026d83c68d772.png";